import { PlayerApp } from './app';
import { loadConfig } from './config';
import { showFatal } from './startup';

const root = document.getElementById('app');
if (!root) throw new Error('#app mancante');

try {
  const cfg = loadConfig();
  const app = new PlayerApp(cfg, root);
  // `start` ritenta da solo e mostra l'errore a schermo; questo catch è solo l'ultima rete di sicurezza
  app.start().catch((e: unknown) => {
    console.error('avvio fallito', e);
    showFatal(root, e instanceof Error ? `${e.name}: ${e.message}` : String(e));
  });
} catch (e) {
  // errore nella costruzione (prima che esista la UI): mai nero muto
  console.error('avvio fallito', e);
  showFatal(root, e instanceof Error ? `${e.name}: ${e.message}` : String(e));
}

// Service worker: solo app shell, così il player si riavvia offline. Non intercetta API né media.
// Nei contesti non sicuri (http su IP di LAN) `navigator.serviceWorker` non esiste: si salta.
if ('serviceWorker' in navigator && /^https?:$/.test(location.protocol) && !import.meta.env.DEV) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('./sw.js').catch(() => undefined);
  });
}
